import { heroImages, images } from './images';
import type { Service } from '../types/content';

export const services: Service[] = [
  {
    id: 'roadworks',
    title: 'Roadworks Construction & Maintenance',
    summary: 'Road construction, reconstruction, layer works and maintenance.',
    overview:
      'Road construction and reconstruction from roadbed preparation through layered subbase and base construction, compaction and surfacing, along with maintenance and rehabilitation of existing roads.',
    scope: [
      'Road construction and reconstruction',
      'Roadbed construction',
      'Base and subbase preparation, soaking and processing',
      'Compaction of road layers',
      'Gravel roads, including G5 gravel layers',
      'Double seal surfacing and asphalt overlay',
      'Road maintenance and rehabilitation',
    ],
    image: images.roadGrader,
    relatedProjectIds: [
      'a3-francistown-nata-section-1',
      'francistown-kutamogoree-road',
      'kanye-mheelo-minimal-services',
      'phakalane-roads',
      'setlhoa-village-reticulation',
    ],
  },
  {
    id: 'civil',
    title: 'Civil Engineering & Infrastructure',
    summary: 'Site preparation, earthworks and infrastructure construction.',
    overview:
      'General civil works for public, mining and commercial clients: site preparation, bulk earthworks, platforms and access roads, slope works and the services infrastructure that developments depend on.',
    scope: [
      'Site establishment and preparation',
      'Bulk earthworks and platforms',
      'Access road construction',
      'Dismantling and disposal of redundant structures',
      'Slope maintenance and stabilisation',
      'Civil, structural, electrical and telemetry works on mine infrastructure',
      'Roads, water and sewer services for campsites and developments',
    ],
    image: heroImages.roads,
    relatedProjectIds: [
      'khoemacau-boxcut-slope',
      'orapa-tailings-conveyor',
      'orapa-om1-conveyor-disposal',
      'karowe-campsite-infrastructure',
      'orapa-ssd-resource-centre',
    ],
  },
  {
    id: 'water',
    title: 'Water, Waste Management & Sanitation',
    summary: 'Water reticulation, pump stations, sewer and wastewater works.',
    overview:
      'Water and wastewater (sanitation) civil works: potable water reticulation, pump stations, sewer networks, vacuum sewer refurbishment, treatment plant installation and storage tanks.',
    scope: [
      'Potable water reticulation',
      'Pump stations and pump houses',
      'Sewer and wastewater reticulation',
      'Vacuum sewer system refurbishment',
      'Containerised wastewater treatment plant installation',
      'Elevated and galvanised steel storage tanks',
      'Effluent holding dams and HDPE-lined ponds',
      'Electrical and telemetry works for pump stations',
    ],
    image: images.pipework,
    relatedProjectIds: [
      'goodhope-vacuum-sewer',
      'gaborone-wastewater-pump-stations',
      'orapa-water-reticulation',
      'serowe-sewer-effluent-irrigation',
      'matsiloje-steel-storage-tank',
    ],
  },
  {
    id: 'drainage',
    title: 'Stormwater Drainage & Culverts',
    summary: 'Stormwater systems, channels, culverts and drifts.',
    overview:
      'Stormwater drainage, channels, culverts and drifts, delivered as part of road, building and township infrastructure projects.',
    scope: [
      'Stormwater drainage reticulation',
      'Stormwater channels',
      'Culverts and drifts',
      'Stormwater concrete works',
      'Stormwater connections to council networks',
    ],
    image: images.culvert,
    relatedProjectIds: [
      'kanye-mheelo-minimal-services',
      'mahalapye-prison-staff-housing',
      'lobatse-railway-station',
      'setlhoa-village-reticulation',
      'mphuthe-cjss-hostels',
    ],
  },
  {
    id: 'building',
    title: 'Building & Structural Works',
    summary: 'Hostels, housing, academic, station and steel-framed buildings.',
    overview:
      'Building and structural construction for institutional, public and industrial clients, from multi-storey hostels and staff housing to steel-framed workshops, plus refurbishment of existing facilities.',
    scope: [
      'Multi-storey hostel blocks',
      'Staff housing',
      'Academic and classroom buildings',
      'Railway station waiting rooms and ticket office',
      'Steel-framed workshops with I-section columns, steel trusses and IBR roofing',
      'Change rooms and ablution blocks',
      'Refurbishment and maintenance of institutional facilities',
      'Boundary and perimeter walls',
    ],
    image: images.buildingWorks,
    relatedProjectIds: [
      'mphuthe-cjss-hostels',
      'lobatse-railway-station',
      'bmc-lobatse-workshop',
      'tawana-preschool',
      'kanye-prison-maintenance',
    ],
  },
  {
    id: 'paving',
    title: 'Paving, Traffic Signs & Road Furniture',
    summary: 'Interlocking paving, fencing, road markings, signs and furniture.',
    overview:
      'Road paving and fencing, road markings, and traffic signs and road furniture are listed among the services the company offers. Its documented projects include paved access roads, car parks and palisade fencing.',
    scope: [
      'Interlocking paving for access roads and car parks',
      'Road markings',
      'Traffic signs and road furniture',
      'Fencing, including palisade fencing',
      'Road maintenance',
    ],
    image: images.paving,
    relatedProjectIds: ['kanye-prison-maintenance', 'lobatse-railway-station', 'bowasetso-park', 'orapa-ssd-resource-centre'],
    reviewNote:
      'Road markings, traffic signs and road furniture appear in the services list, but no specific project for them is documented. Add examples if there are any.',
  },
];
